import React, { useRef, useState, useEffect } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import axios from "axios";
import AgGridDataTable from "../../shared/utilities/AgGridDataTable";


const TransporterVariances = (props) => {
  const agGridRef = useRef();
  const [result, setResult] = useState([]);
  useEffect(() => {
    getTransImages();
  }, []);
  const getTransImages = async () => {
    await axios
      .get(`/api/v1/hwts/search/transporter/variance?RegID=${props.regID}`)
      .then((res) => {
        setResult(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const columnDefs = [
    {
      headerName: "Variance", field: "VAR", width: 130,
    },
    {
      headerName: "Effective", field: "EFF", width: 90,
    },
    {
      headerName: "Expires", field: "EXP", width: 90,
    },
  ];

  return (

    <div className="facility-address-card">
      <h3
        style={{
          textAlign: "center",
        }}
      >
        Transporter Variance
      </h3>
      {result.length === 0 ? <div>No Terminal Variance associated with this Transporter Registration.</div>
        :

        <div>
          <AgGridDataTable
            pageTitle={`Transporter Profile: ${props.transName} (${props.regID})`}
            agGridRef={agGridRef}
            columnDefs={columnDefs}
            rowData={result}
            initialPageSize={10}
            hidePagination={true}
          />
        </div>
      }
    </div>

  );
};

export default TransporterVariances;
